import { CashBuildElementIdEnum } from '@shared/Enums/CashBuildElementIdEnum';

const APP_MODE = import.meta.env.VITE_APP_MODE;
const MOCK_EMAIL = import.meta.env.VITE_MOCK_EMAIL;

export function GetHostEmail(): string | null {
    const needEmailToLogin = APP_MODE === 'dev';
    if (needEmailToLogin) return MOCK_EMAIL;

    const root = document.getElementById(CashBuildElementIdEnum.ROOT_CASHBUILD);
    return root?.getAttribute(CashBuildElementIdEnum.EMAIL) || null;
}
